<template>
    <div class="user-center__content-title">
       {{ title }} 
    </div>
</template>

<script>
export default {
    name: 'UserCenterContentTitle',
    props: {
        title: {
            type: String,
            required: true,
            default: ''
        }
    }
}
</script>

<style>
.user-center__content-title{
    padding: 40px 0 20px 50px;
    border-bottom:1px solid var(--src-color-secondary-light5);
    font-size: var(--src--text-size-large-extra3);
    color: var(--src-color-primary-deep);
    font-weight: var(--src-text-weight-dark1);
}
</style>


// WEBPACK FOOTER //
// src/components/pages/UserCenterContentTitle.vue